// extracted by mini-css-extract-plugin
module.exports = {"infoText":"-PXEv"};